export default class Grain
{
    constructor(
        id,
        name,
        enterprises
    ) {
        this.id = id;
        this.name = name;
        this.enterprises = enterprises;
    }
}



// WEBPACK FOOTER //
// ./apiClient/ReadModels/Grain.js